"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WrappedButton;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Theme = require("../Theme");

var _Util = require("../Util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function WrappedButton(props) {
  var newProps = (0, _Util.mergeProps)(props, WrappedButton, ['style']);

  var children = newProps.children,
      rounded = newProps.rounded,
      style = newProps.style,
      rest = _objectWithoutProperties(newProps, ["children", "rounded", "style"]);

  var styles = Object.assign({}, style, {
    boxShadow: 'none',
    textTransform: 'capitalize'
  });

  if (rest.color === 'danger') {
    if (rest.variant === 'contained') {
      styles.backgroundColor = _Theme.colors.danger;
      styles.color = _Theme.colors.white;
    } else {
      styles.borderColor = _Theme.colors.danger;
      styles.color = _Theme.colors.danger;
    }
  }

  if (!rest.color || rest.color === 'default') {
    if (rest.variant === 'contained') {
      styles.backgroundColor = rest.disabled ? _Theme.colors.lightGrey : _Theme.colors.primary;
      styles.color = _Theme.colors.white;
    } else {
      styles.borderColor = rest.disabled ? _Theme.colors.lightGrey : _Theme.colors.primary;
      styles.color = rest.disabled ? _Theme.colors.lightGrey : _Theme.colors.primary;
    }
  }

  if (rest.color === 'reverse') {
    if (rest.variant === 'contained') {
      styles.backgroundColor = 'rgba(255, 255, 255, 0.9)';
      styles.color = _Theme.colors.primary;
    } else {
      styles.borderColor = _Theme.colors.primary;
      styles.color = _Theme.colors.primary;
    }
  }

  if (rounded) {
    styles.borderRadius = {
      small: 16,
      medium: 18,
      large: 20
    }[rest.size];
  }

  return _react["default"].createElement(_Button["default"], Object.assign({
    style: styles
  }, rest), children);
}

WrappedButton.propTypes = {
  children: _propTypes["default"].any.isRequired,
  style: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  size: _propTypes["default"].oneOf(['large', 'medium', 'small']),
  rounded: _propTypes["default"].bool
};
WrappedButton.defaultProps = {
  rounded: false,
  size: 'medium',
  style: {}
};